<template>
  <div class="header-card" id="headercard">
    <div class="header-card__info">
      <div class="header-card-top">
        <img
          class="header-card__img"
          v-if="imgUrl && this.isSmAndDown"
          :src="imgUrl"
          alt="Evento"
        />
        <event-logo v-else-if="this.isSmAndDown" class="header-card__img" />
        <div
          :class="
            this.isSmAndDown ? 'mr-2 header-card__exit' : 'header-dt-card__exit'
          "
        >
          <Countdown
            v-if="expiration"
            :style="!this.isSmAndDown ? 'margin-top: -38px;' : ''"
            :date="expiration"
          />
          <v-btn
            v-if="isIframe"
            :style="!this.isSmAndDown ? 'margin-top: -38px;' : ''"
            flat
            dark
            icon
            @click="exit"
          >
            <v-icon>clear</v-icon>
          </v-btn>
          <!-- Não remover hidden btn, necessario para responsividade Safari -->
          <v-btn
            flat
            v-else-if="!isIframe && !expiration"
            :style="
              !this.isSmAndDown
                ? 'margin-top: -38px; pointer-events: none;'
                : 'pointer-events: none;'
            "
          ></v-btn>
        </div>
      </div>
      <v-card-text>
        <v-layout>
          <v-flex :class="this.isSmAndDown ? 'xs12' : 'xs9'">
            <h1
              :class="
                this.isSmAndDown ? 'mobile-header-title mt-3' : 'checkout-h1'
              "
              :style="$route.name === 'totem' ? 'margin-left: -10px' : ''"
            >
              <v-btn
                v-if="$route.name === 'totem'"
                color="primary"
                depressed
                text
                icon
                @click="backEvents"
                ><v-icon>la-angle-left</v-icon></v-btn
              >{{ name }}
            </h1>
            <h3
              v-if="
                !(
                  currentStep === 1 &&
                  filteredPresentations.length &&
                  !$route.query.listar_apresentacoes
                )
              "
              class="checkout-h3"
            >
              {{ date }}
            </h3>
            <h3 class="checkout-h3">{{ place }}</h3>

            <div class="row">
              <v-btn
                v-if="
                  ((!$vuetify.breakpoint.mdAndUp &&
                    filteredPresentations &&
                    filteredPresentations.length) ||
                    (filteredPresentations &&
                      filteredPresentations.length &&
                      filteredPresentations.length >= 5)) &&
                    !$route.query.listar_apresentacoes &&
                    currentStep === 1
                "
                fab
                small
                color="primary"
                depressed
                @click="handleLeft"
              >
                <v-icon color="white">keyboard_arrow_left</v-icon>
              </v-btn>

              <div
                v-if="
                  currentStep === 1 &&
                    filteredPresentations.length &&
                    !$route.query.listar_apresentacoes
                "
                class="limited-line my-2"
              >
                <presentation-card
                  :eventDetails="eventDetails"
                  :presentations="filteredPresentations"
                  :cartProducts="cartProducts"
                />
              </div>

              <v-btn
                v-if="
                  ((!$vuetify.breakpoint.mdAndUp &&
                    filteredPresentations &&
                    filteredPresentations.length) ||
                    (filteredPresentations &&
                      filteredPresentations.length &&
                      filteredPresentations.length >= 5)) &&
                    !$route.query.listar_apresentacoes &&
                    currentStep === 1
                "
                @click="handleRight"
                class="ml-4"
                fab
                small
                color="primary"
                depressed
              >
                <v-icon color="white">keyboard_arrow_right</v-icon>
              </v-btn>
            </div>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex shrink v-if="!this.isSmAndDown">
            <div class="header-card-top">
              <img
                class="header-dt-card__img"
                v-if="imgUrl"
                :src="imgUrl"
                alt="Evento"
              />
              <event-logo v-else class="header-dt-card__img" />
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </div>
    <v-divider></v-divider>
  </div>
</template>

<script>
import EventLogo from '../UI/logo/EventLogo';
import Countdown from '../UI/Countdown';
import { mapGetters } from 'vuex';
import PresentationCard from './header/PresentationCard.vue';

export default {
  data() {
    return {
      isIframe: true,
    };
  },
  props: ['name', 'place', 'date', 'imgUrl'],
  components: { EventLogo, Countdown, PresentationCard },

  computed: {
    ...mapGetters(['currentStep', 'eventDetails', 'cartProducts', 'eventID']),

    expiration() {
      return this.$store.getters.body.expiration || 0;
    },
    currentStep() {
      return this.$store.getters.currentStep;
    },

    filteredPresentations() {
      if (
        this.eventDetails &&
        this.eventDetails.relacionados &&
        this.eventDetails.relacionados.length
      ) {
        let filteredPresentations = this.eventDetails.relacionados.filter(
          presentation => {
            let endDate = this.$moment.unix(presentation.data_encerramento_ts);

            let today = this.$moment();

            return !endDate.isBefore(today);
          }
        );

        return filteredPresentations;
      }

      return [];
    },
  },

  methods: {
    async handleRight() {
      await this.scrollSmoothly(300);
    },

    async handleLeft() {
      await this.scrollSmoothly(-300);
    },

    scrollSmoothly(amount) {
      const limitedLine = document.getElementsByClassName('limited-line')[0];
      const targetScroll = limitedLine.scrollLeft + amount;
      const duration = 500;
      const startTime = performance.now();

      function step(currentTime) {
        const elapsedTime = currentTime - startTime;
        const scrollProgress = Math.min(elapsedTime / duration, 1);
        limitedLine.scrollLeft = easeInOutQuad(
          limitedLine.scrollLeft,
          targetScroll,
          scrollProgress
        );

        if (scrollProgress < 1) {
          requestAnimationFrame(step);
        }
      }

      function easeInOutQuad(start, end, progress) {
        return (
          start +
          (end - start) *
            (progress < 0.5
              ? 2 * progress * progress
              : 1 - Math.pow(-2 * progress + 2, 2) / 2)
        );
      }

      requestAnimationFrame(step);
    },

    exit() {
      this.$emit('exit');
    },
    backEvents() {
      if (this.currentStep === 2) {
        if (this.$route.name === 'totem') this.$store.dispatch('backAStep');
        this.$store.dispatch('backAStep');
      } else {
        this.$router.push('/event/natal-luz');
        this.$store.commit('SET_EVENT_MAP', null);
      }
    },
  },

  mounted() {
    setTimeout(() => {
      const cardEvent = document.getElementById(this.eventID);

      if (cardEvent) {
        let position = cardEvent.getBoundingClientRect();

        const limitedLine = document.getElementsByClassName('limited-line')[0];

        limitedLine.scrollLeft = position.left - 280;
      }
    }, 660);

    if (window.location.pathname.replace('/', '')) {
      this.isIframe = false;
    }
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/modal/modalHeader.styl';
</style>

<style scoped>
.limited-line {
  flex: 1;
  white-space: nowrap;
  overflow-x: hidden;
  padding: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  scroll-behavior: smooth !important;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
